import { Divider, Flex, Paper, Skeleton } from "@mantine/core"
import { FilterInputListSkeleton } from "../FilterInputList"
import { useMediaQuery } from "@mantine/hooks"

export const FilterSkeleton = () => {
	const isSmallMobile = useMediaQuery("(max-width: 580px)")

	return (
		<Paper bg="gray.0" radius={10}>
			<Flex py={24} px={16}>
				<FilterInputListSkeleton />
			</Flex>
			<Divider color="gray.1"></Divider>
			<Flex
				p={16}
				justify="space-between"
				align="center"
				wrap="wrap"
				gap={16}
				direction={isSmallMobile ? "column" : "row"}
			>
				<Skeleton
					variant="transparent"
					fw={400}
					fz={16}
					c="dark.3"
					h={50}
					w={isSmallMobile ? "100%" : "auto"}
					p={0}
				>
					Очистить фильтр
				</Skeleton>
				<Skeleton h={50} fw={600} fz={16} w={isSmallMobile ? "100%" : "auto"} />
			</Flex>
		</Paper>
	)
}
